<template>
  <footer class="footer-bar">
    <small>Последнее обновление: {{ lastUpdated ? formatDateTime(lastUpdated) : '—' }}</small>
  </footer>
</template>

<script>
import { formatDateTime } from './utils/helpers';
export default { name: 'FooterBar', props: { lastUpdated: { type: [String, Date], default: null } }, methods: { formatDateTime } };
</script>

<style scoped>
.footer-bar{display:flex;justify-content:flex-end;color:#64748b}
</style>